<div class="flex flex-col h-full w-full justify-start items-start gap-6 pb-6 font-medium bg-[#FFF]">

    <app-hoai-stepper #stepper [(selectedStep)]="selectedStep" [nextStepAllowed]="true" [previousStepAllowed]="true"
                      class="w-full"></app-hoai-stepper>

    <!-- Overview Report containing Leistungsphase, Date, Prüfer, Project name etc. -->
    <div class="flex flex-col w-full flex-1 min-h-0 justify-start items-start gap-6 px-6 overflow-hidden">
      <app-overview-reports (download)="downloadPdf()"
                            [activateDownload]="!loading"
                           [info1]="'Gebäude und Innenräume'"
                           [info2]="'Leistungsphase ' + ((lph ? (lph | lphToNumber) : 0) + 1)"
                           checkType="HOAI"
                           [checkerName]="(hoaiCheck?.checker?.firstName ?? '') + ' ' + (hoaiCheck?.checker?.lastName ?? '')"
                           [completedValue]="completed"
                            [date]="$safeNavigationMigration(hoaiCheck?.checkDate)"
                           [errorValue]="error"
                           [fileDeactivated]="false"
                            [loading]="loading"
                           [warningValue]="warning"
                            [rules]="total.toString()"
                           class="w-full">
      </app-overview-reports>

      @if (stepper.selectedStep == 1) {
        <div
          class="border border-gray-200 rounded-lg flex flex-row w-full h-[50px] justify-start items-center p-4 gap-4">
          <fa-icon [icon]="faCircleInfo" class="text-[16px] text-[#9BABB2]"></fa-icon>
          <div class="flex flex-row justify-start items-center gap-1">
            <p class="text-[12px] font-medium text-gray">Hinweis KI-generierte Inhalte:</p>
            <p class="text-[12px] text-gray">Teile der Inhalte wurden automatisch mit KI erstellt und sollten bei
              Bedarf auf Richtigkeit geprüft werden.</p>
          </div>
        </div>

        <div class="flex w-full flex-1 min-h-0">
          <bic-result>
            <bic-result-column (selectedElementChange)="selectedFile = undefined"
                               [(selectedElement)]="selectedRule"
                               [style.flex]="columnWidths.rules + ' 1 0%'" [style.max-width]="'100%'"
                               [style.min-width]="'0'">
              <bic-result-header header>
                <div>
                  Teilleistungen
                </div>
              </bic-result-header>

              @if (loading) {
                <bic-result-row [disableTasks]="true" [hidden]="true"></bic-result-row>
                <div class="flex flex-col flex-1 h-full justify-center items-center py-16">
                  <div class="flex flex-row items-center gap-2">
                    <fa-icon [icon]="faSpinnerThird" class="text-gray-500 animate-spin text-svg-16"></fa-icon>
                    <span class="text-sm font-medium text-gray-500">Ergebnisse werden geladen...</span>
                  </div>
                </div>
              } @else {
              @for (rule of rules | sortHoaiRules; track rule?.id) {
                <bic-result-row #row
                                (taskClicked)="createTaskForRule(rule)"
                                [status]="statusForRuleResult(rule)"
                                [value]="rule">
                  <div class="flex flex-row flex-1 gap-4 min-w-0 items-center">
                    <div class="text-center flex-shrink-0">
                      {{ getRuleTypeLabel(rule) }}
                    </div>

                    <div class="truncate">
                      {{ rule!.readableName }}
                    </div>
                  </div>
                </bic-result-row>
              }
              }

            </bic-result-column>

            <bic-result-column [(selectedElement)]="selectedFile"
                               [hide]="selectedRule && projectFilesForSelectedRule.length == 0"
                               [style.flex]="columnWidths.files ? columnWidths.files + ' 1 0%' : null"
                               [style.max-width]="columnWidths.files != null ? '100%' : null"
                               [style.min-width]="columnWidths.files != null ? '0' : null"
                               emptyText="Bitte Teilleistung auswählen">
              <bic-result-header header>
                <div>
                  Dateien
                </div>
              </bic-result-header>
              @for (file of projectFilesForSelectedRule; track file.id) {
                <bic-result-row #row
                                (taskClicked)="createTaskForRuleAndSelectedFile(file)"
                                [status]="statusForProjectFile(file)"
                                [value]="file">
                  <div class="flex flex-row flex-1 gap-4 min-w-0 items-center">
                    <div class="truncate">
                      {{ file!.name }}
                    </div>
                  </div>
                </bic-result-row>
              }
            </bic-result-column>


            <bic-result-column [style.flex]="columnWidths.detail + ' 1 0%'"
                               [style.max-width]="'100%'" [style.min-width]="'0'"
                               emptyText="Bitte Datei auswählen">
              <bic-result-header header>
                <div>
                  Ergebnis
                </div>
              </bic-result-header>


              @if (selectedFile || (selectedRule && projectFilesForSelectedRule.length == 0)) {
                <bic-result-row [disableTasks]="true" [lineBreaksDisabled]="false">
                  <div class="flex flex-col h-full">
                    @if (selectedRule && projectFilesForSelectedRule.length == 0) {
                      <div class="flex flex-row items-center gap-4 py-2 px-4">
                        <div class="flex flex-col justify-center items-center text-base flex-shrink-0">
                          <fa-icon [icon]="faCircleXmark" class="text-red"></fa-icon>
                        </div>
                        <div class="flex flex-col text-xs gap-2">
                          <div class="text-gray-500 font-medium">
                            Keine Dokumente gefunden
                          </div>
                          <div>
                            Es konnten keine Dokumente identifiziert werden, die als potenzielle Nachweise zur Erfüllung
                            der Teilleistung in Betracht gezogen werden können.
                          </div>
                          <div>
                            Zur Erfüllung dieser Teilleistung können die folgenden Dokumentenarten eingereicht werden:
                          </div>
                          <div class="flex flex-row gap-2">
                            @for (classification of selectedRule.classifications; track classification) {
                              <bic-badge type="info">{{ classificationNameForId(classification) }}</bic-badge>
                            }
                          </div>
                        </div>
                      </div>
                    } @else {
                      @for (result of resultOfSelectedProjectFileAndSelectedRule; track $index; let last = $last) {
                        <div class="flex flex-row items-center gap-4 py-2 px-4">
                          <div class="flex flex-col justify-center items-center text-base flex-shrink-0">
                            @if (result.type == "CLASSIFICATION") {
                              <fa-icon [icon]="faCircleInfo" class="text-gray-900"></fa-icon>
                            } @else {
                              @switch (result.result) {
                                @case ("SUCCESS") {
                                  <fa-icon [icon]="faCircleCheck" class="text-green"></fa-icon>
                                }
                                @case ("WARNING") {
                                  <fa-icon [icon]="faCircleExclamation" class="text-yellow"></fa-icon>
                                }
                                @case ("FAILURE") {
                                  <fa-icon [icon]="faCircleXmark" class="text-red"></fa-icon>
                                }
                              }
                            }
                          </div>
                          <div class="flex flex-col text-sm">
                            <div class="text-gray-500 font-medium">
                              @switch (result.type) {
                                @case ("CLASSIFICATION") {
                                  Klassifizierung - Grobe Einordnung in Kategorien von Dokumenten
                                }
                                @case ("IDENTIFICATION") {
                                  Identifikation - Prüfung der Dokumentenart
                                }
                                @case ("SCOPE1") {
                                  Anwendungsbereich - Prüfung der Leistungsbilder und Fachdisziplinen
                                }
                                @case ("CONTENT") {
                                  Inhalt - Prüfung der inhaltlichen Anforderungen
                                }
                              }
                            </div>
                            <div>
                              {{ result.answer }}
                            </div>
                          </div>
                        </div>
                        @if (!last) {
                          <div class="border-t -mx-8"></div>
                        }
                      }
                    }


                  </div>
                </bic-result-row>
              }

            </bic-result-column>
          </bic-result>

        </div>
      }

      @if (stepper.selectedStep == 0) {
        <app-files
          [calledFromCheck]="true"
          [customFilesActivated]="true"
          [customFiles]="hoaiCheck.projectFiles ?? []"
          [filterAndContextButtonActivated]="false"
          [headline]="'Geprüfte Dateien'"
          [noOuterPadding]="true" class="flex w-full h-full">
        </app-files>

        <div class="flex flex-row w-full justify-center items-center">

          <bic-button (click)="stepper.changeStep(1)">
            Prüfergebnisse
            <fa-icon [icon]="faChevronRight" iconRight></fa-icon>
          </bic-button>
        </div>
      }

    </div>

    <!--  notice for AI contents -->

  </div>

